import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { CustomAuthService } from '../services/custom-auth.service';

const SUPERADMIN_EMAILS = [
    'vincent@ares.sale',
    'roban@ares.sale'
];

export const superadminGuard: CanActivateFn = () => {
    const authService = inject(CustomAuthService);
    const router = inject(Router);

    // Wait for auth to finish loading before checking user
    return authService.isLoading$.pipe(
        filter(isLoading => !isLoading),
        take(1),
        switchMap(() => authService.user$),
        take(1),
        map(user => {
            if (!user) {
                router.navigate(['/login']);
                return false;
            }

            const isSuperadmin = SUPERADMIN_EMAILS.includes(user.email.toLowerCase());

            if (!isSuperadmin) {
                router.navigate(['/']);
                return false;
            }

            return true;
        })
    );
};
